import { default as context } from '@truckdown/systems';

import { VueCreatorInitializer } from './VueCreatorInitializer';
import { VueMountInitializer } from './VueMountInitializer';
import { OneSignalInitializer } from './OneSignalInitializer';
import { IconLoader } from './IconLoader';
import { IAppUserContext } from '../IAppUserContext';
import { NotificationReceivedHandler } from "./NotificationReceivedHandler";

const handlers: ((evt: NotificationReceivedHandler) => Promise<void>)[] = [];

let appContext = context as IAppUserContext;
appContext.analytics = (data: any) => {
    if ((window as any).dataLayer) {
        (window as any).dataLayer.push(data)
    }
};

appContext.requestNotificationPermission = async () => {
    if (appContext.isAuthenticated) {
        if (window.Notification && !appContext.oneSignal) {
            appContext.settings['osnpr'] = 'true';
        } else if (appContext.oneSignal && appContext.oneSignal.Notifications.isPushSupported()) {
            await appContext.oneSignal.Notifications.requestPermission();
        }
    }
}

appContext.registerNotificationReceivedHandler = function (handler: (evt: NotificationReceivedHandler) => Promise<void>) {
    handlers.push(handler);
}

appContext.deregisterNotificationReceivedHandler = function (handler: (evt: NotificationReceivedHandler) => Promise<void>) {
    let idx = handlers.indexOf(handler);
    if (idx >= 0) {
        handlers.splice(idx, 1);
    }
}

appContext.triggerNotificationReceived = async function (handler: NotificationReceivedHandler) {
    if (handlers.length == 0) {
        return handler;
    }

    for (let i = 0; i < handlers.length; i++) {
        try {
            await handlers[i](handler);
        }
        catch (err) {
            console.log(err);
        }
    }

    return handler;
}

const vueCreator = new VueCreatorInitializer();
const vueMounter = new VueMountInitializer();
const oneSignalInitializer = new OneSignalInitializer();
const iconLoader = new IconLoader();

context.registerService({
    name: 'IIconLoader',
    activator: async () => {
        return iconLoader;
    }
});
context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return vueCreator;
    }
});
context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return oneSignalInitializer;
    }
});
context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return vueMounter;
    }
});